

export class TaskType {
    static readonly DRIVE_TEST = 'drive test'
    static readonly PATH_TEST = 'path test'
    static readonly SCOUT = 'scout'
}

export type TaskTypeName = 'drive test' | 'path test' | 'scout'